import React from "react";
import ReactDOM from "react-dom/client";
import { App as AntdApp, ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { FK_ANTD_THEME } from "./design/antdTheme";
// Порядок важен: шрифты (Manrope/Quicksand/JetBrains Mono, свои файлы /fonts) → токены →
// глобальные стили → словарь mk-*.
import "./design/fonts.css";
import "./design/tokens.css";
import "./ui.css";
import "./marketing/marketing.css";
import "./design/studio.css";
import "./design/fishka.css";
// Оболочка (каркас CRM v2) — последней: её размеры (--fk-topbar-h, --fk-sidebar-w) главнее studio.css.
import "./design/shell.css";

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      // maxCount ограничивает стопку тостов: больше трёх плашек на экране не копится.
      <AntdApp message={{ maxCount: 3 }}>
        <App />
      </AntdApp>
    ),
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={ruRU}
      theme={FK_ANTD_THEME}
    >
      <QueryClientProvider client={qc}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
